



















import Vue, { PropOptions } from 'vue';
import {
  AppRoute,
  AppRouteSection,
  AppRouteSectionAction,
  Permission,
} from '../../data/routes';
import sidebarStore from '../../store/modules/sidebar';

import PermissionMixin from '../../mixins/Permission.mixin';
import SNavigationItem from './SNavigationItem.vue';

export default Vue.extend({
  name: 'SNavigationSidebar',
  components: {
    SNavigationItem,
  },
  mixins: [PermissionMixin],
  props: {
    /**
     * An array of `AppRoute` types. See `src/data/routes` for the type definition
     */
    routes: {
      type: Array,
      required: true,
    } as PropOptions<AppRoute[]>,

    /**
     * Whether the list should have the dense modifier applied
     */
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data(): any {
    return {};
  },
  computed: {
    permissions(): any {
      let rules: any;

      // Don't die if we don't have these stores. Roles and permissions should be optional
      // as not all apps using this baseplate may need them.
      // TODO - This baseplate should register the stores required for this functionality
      // It shouldn't be down to the app implementing the baseplate to re-implment these stores
      // each time
      if (!this.$store.state.authorization || !this.$store.state.roles) {
        return undefined;
      }

      const roleId = this.$store.state.authorization
        ? this.$store.state.authorization.role
        : undefined;

      const role = this.$store.state.roles.roles[roleId]
        ? this.$store.state.roles.roles[roleId]
        : undefined;

      if (role && role.rules) ({ rules } = role);

      return rules;
    },
    filteredRoutes(): AppRoute[] {
      return this.routes.filter((route) => this.isUserAllowedToSee(route));
    },
  },
  created(): void {
    const store = this.$store;
    if (!(store && store.state && store.state.sidebar)) {
      store.registerModule('sidebar', sidebarStore);
    } else {
      console.log('reusing module: sidebar');
    }
  },
  methods: {
    isUserAllowedToSee(route: AppRoute) {
      if (route.permissions == null) return true;

      const isPermissionValid = (permission: Permission) => {
        if (typeof permission === 'string') {
          return this.hasPermissions(permission);
        }

        const { relation, permissions } = permission;
        const arrayCompareMethod = relation === 'OR' ? 'some' : 'every';
        return permissions[arrayCompareMethod](isPermissionValid);
      };

      return route.permissions.every(isPermissionValid);
    },
    getSectionHeadingAction(
      route: AppRouteSection,
    ): AppRouteSectionAction | null {
      if (!route.action) {
        return null;
      }

      if (route.action.permissions) {
        return this.hasPermissions(...route.action.permissions)
          ? route.action
          : null;
      }

      return route.action;
    },
  },
});
